'use client';

import React from 'react';
import { StrategyListGenerator } from '../index';
import { ALL_TYPES_EXCEPT_CRM_STATUS } from 'src/components/DynamicCriteriaGenerator/constants';
import { LOCATION } from 'src/hooks/filters/constants';
import { StrategyConfigProps } from 'src/components/Strategy/config';

const TreatingVolumeConfiguration: React.FC<StrategyConfigProps> = ({
  location = LOCATION.STRATEGY,
}) => {
  return (
    <div className="flex flex-col gap-4">
      <StrategyListGenerator
        allowedTypes={ALL_TYPES_EXCEPT_CRM_STATUS}
        strategyType="TREATING_VOLUME"
        location={location}
      />
    </div>
  );
};

export default TreatingVolumeConfiguration;
